import styled from 'styled-components'

const Title = styled.h1`
  font-size: calc(100vw * (23 / 375));
  font-weight: 700;
  line-height: calc(100vw * (35 / 375));
  color: #121212;
  margin-bottom: calc(100vw * (8 / 375));
  white-space: pre-wrap;
`

export default Title
